import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const sentinel = this.element.previousElementSibling
    if (!sentinel) return

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].intersectionRatio === 0) {
          this.element.classList.add("js-sticky")
        } else if (entries[0].intersectionRatio === 1) {
          this.element.classList.remove("js-sticky")
        }
      },
      { threshold: [0, 1], rootMargin: `-${this.element.offsetHeight}px` }
    )

    this.observer.observe(sentinel)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
